import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../app/api/axiosInstance";

const cartState = {
    loading: false,
    mutating: false,
    cartList: [],
    cartCount: 0,
    wishListCount: 0,
    cartAmount: 0,
    deliverySlot: [],
    takeAwaySlot: [],
    deliveryAddress: [],
    timeSlot: [],
    cartListRemoved: [],
    cartListNew: [],
    freeProducts: [],
    outOfStock: false,
    placeOrderStatus: false,
    totalDiscount: 0,
    subTotal: 0,
    orderId: 0,
    error: "",
    response: "",
    cartStatus: false,
    lastFetchCartRequestId: null,
};

export const addCart = createAsyncThunk("cart/addCart", async (_, { getState }) => {
    const { cart, auth } = getState();
    if (cart.cartStatus) {
        const user = auth.user;
        const response = await axiosInstance.post(`${process.env.REACT_APP_CART_BASE_URL}/cart/add/`, {
            tempID: user.name,
            customerId: user.customerId,
            cart: [...cart.cartListNew, ...cart.cartListRemoved],
        });
        return response.data;
    }
});

export const fetchCart = createAsyncThunk("cart/fetchCart", async (_, { getState }) => {
    const { auth } = getState();
    const token = auth.token;
    const branch = JSON.parse(localStorage.getItem("selectedBranch"));
    if (token) {
        const response = await axiosInstance.get(
            `${process.env.REACT_APP_CART_BASE_URL}/cart/get/?branchId=${branch.id}&_=${Date.now()}`
        );
        return response.data;
    }
    return [];
});

export const fetchDeliverySlot = createAsyncThunk("delivery/getSlots", async (data) => {
    console.log(data);
    const branch = JSON.parse(localStorage.getItem("selectedBranch"));
    const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/delivery/getSlots?branchId=${branch.id}&cartValue=${data.finalAmount}`);
    return response.data;
});

export const fetchTakeawaySlot = createAsyncThunk("delivery/getTakeawaySlots", async () => {
    const branch = JSON.parse(localStorage.getItem("selectedBranch"));
    const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/takeAway/getSlots?branchId=${branch.id}`);
    return response.data;
});

export const fetchDeliveryAddress = createAsyncThunk("delivery/getAddress", async () => {
    const response = await axiosInstance.get(`${process.env.REACT_APP_CUSTOMER_BASE_URL}/customer/getAddress`);
    return response.data;
});

export const checkCartStatus = createAsyncThunk("cart/checkCartStatus", async (_, { getState }) => {
    const { auth } = getState();
    const user = auth.user;
    const token = auth.token;
    const branch = JSON.parse(localStorage.getItem("selectedBranch"));
    if (token) {
        const response = await axiosInstance.get(
            `${process.env.REACT_APP_CART_BASE_URL}/cart/check/?branchId=${branch.id}`
        );
        return response.data;
    }
    return [];
});

export const placeOrder = createAsyncThunk("checkout/placeorder", async (data) => {
    const response = await axiosInstance.post(`${process.env.REACT_APP_ORDER_BASE_URL}/orders/checkout`, data);
    return response.data;
});

export const clearCartApi = createAsyncThunk(
    "cart/clearCart",
    async (payload = {}, { getState }) => {
        const { auth } = getState();

        const body = {
            // backend accepts either auth-derived or explicit values:
            customerId: auth?.user?.customerId ?? payload.customerId ?? null,
            tempID: auth?.user?.name ?? payload.tempID ?? null,

            // targeting options (optional)
            cartIds: payload.cartIds ?? null,                 // number|array|"1,2,3"
            productItemIds: payload.productItemIds ?? null,   // number|array|"1,2,3"

            hardDelete: Boolean(payload.hardDelete),
        };

        const res = await axiosInstance.post(
            `${process.env.REACT_APP_CART_BASE_URL}/cart/clear`,
            body
        );
        return res.data;
    }
);

const cartSlice = createSlice({
    name: "cart",
    initialState: cartState,
    reducers: {
        changeStateTrue: (state) => { state.updateState = true; },
        changeStateFalse: (state) => { state.updateState = false; },
        clearResponse: (state) => { state.response = ""; },
        clearStock: (state) => { state.outOfStock = false; },
        clearState: (state) => {
            state.cartList = [];
            state.cartListNew = [];
            state.cartCount = 0;
            state.totalDiscount = 0;
            state.subTotal = 0;
            state.wishListCount = 0;
            state.cartAmount = 0;
            state.deliverySlot = [];
            state.deliveryAddress = [];
            state.timeSlot = [];
            state.error = "";
            state.response = "";
        },
        addToCart: (state, action) => {
            if (state.cartListNew.length > 0) {
                var exists = state.cartListNew.some(el => el.productItemId === action.payload.productItemId);
                if (exists) {
                    state.cartListNew = state.cartListNew.map((item) => {
                        if (item.productItemId === action.payload.productItemId) {
                            item.quantity += 1;
                            item.totalQuantity += 1;
                        }
                        return item;
                    });
                } else {
                    state.cartListNew.push(action.payload);
                }
            } else {
                state.cartListNew.push(action.payload);
            }
            let cartTotalList = [];
            let num = 0;
            state.totalDiscount = 0;
            let cartProducts = JSON.parse(JSON.stringify(state.cartListNew.filter(el => el.productItemId > 0)));
            // console.log(cartProducts, "cartProductsADD");
            cartProducts.forEach((cp, index) => {
                let cps = {};
                let free = {};
                let extra = {};
                var mrp = parseFloat(cp.mrpPrice).toFixed(2);
                var sprice = parseFloat(cp.salesPrice).toFixed(2);
                cps.productItemId = cp.productItemId;
                cps.productName = cp.productName;
                cps.categoryId = cp.categoryId;
                cps.categoryName = cp.categoryName;
                cps.image = cp.image;
                cps.quantity = cp.quantity;
                cps.totalQuantity = cp.quantity;
                cps.stock = cp.stock;
                cps.offer_type = cp.offer_type;
                cps.value_type = cp.value_type;
                cps.offer_Value = cp.offer_Value;
                cps.offer_quantity = cp.offer_quantity;
                cps.offer_products_id = cp.offer_products_id;
                cps.offer_free_quantity = cp.offer_free_quantity;
                cps.mrpPrice = mrp;
                cps.salesPrice = sprice;
                cps.badge = "";
                cps.status = 1;
                if (cp.offer_type === 3) {
                    if (cp.value_type === 0) {
                        cps.price = (mrp - ((cp.offer_Value / 100) * mrp)).toFixed(2);
                        cps.badge = cp.offer_Value + "%";
                    }
                    if (cp.value_type === 1) {
                        cps.price = (mrp - cp.offer_Value).toFixed(2);
                        cps.badge = "₹" + cp.offer_Value;
                    }
                    //                                    console.log((cart.mrpPrice - cart.price) * cart.quantity);
                    state.totalDiscount += (mrp - cps.price) * cp.quantity;
                } else if (cp.offer_type === 4) {
                    cps.price = mrp;
                    cps.badge = "BOGO";
                } else if (cp.offer_type === 5) {
                    if (cp.quantity >= cp.offer_quantity) {
                        cps.badge = "Free";
                        cps.price = mrp;
                        cps.free_product = cp.offer_products_id;
                        let x = Math.floor(cp.quantity / cp.offer_quantity);
                        cps.offer_product_quantity = x;
                        const offPro = (state.freeProducts || []).filter(fp =>
                            fp.offer_products_id === cp.offer_products_id
                        )
                        if (offPro.length > 0) {
                            const fp = offPro[0];
                            free.productName = fp.ProductName ?? fp.productName ?? "Free Item";
                            free.image = Array.isArray(fp.image) ? fp.image[0] : fp.image ?? "";
                            free.offer_products_id = fp.offer_products_id;
                            free.price = 0;
                            free.mrpPrice = 0;
                            free.badge = "Free Product";
                            free.quantity = x * cp.offer_free_quantity;
                            free.totalQuantity = x * cp.offer_free_quantity;
                            free.status = 1;
                        }
                        if ((cp.quantity % cp.offer_quantity) > 0) {
                            let difference = (cp.quantity % cp.offer_quantity);
                            extra.productName = cp.productName;
                            extra.image = cp.image;
                            extra.price = sprice;
                            extra.mrpPrice = mrp;
                            extra.badge = "";
                            extra.quantity = difference;
                            extra.totalQuantity = difference;
                            cps.totalQuantity -= difference;
                        }
                    } else {
                        cps.price = sprice;
                    }
                } else {
                    cps.price = sprice;
                }
                cartTotalList.push(cps);
                if (cp.offer_type === 5 && free.price == 0) {
                    cartTotalList.push(free);
                }
                if (extra.price) {
                    num += extra.quantity * extra.price;
                    cartTotalList.push(extra);
                }
                //                                cps.totalQuantity = cp.quantity;
                num += cps.totalQuantity * cps.price;
            });
            //            state.cartListStatus=state.cartListNew;
            state.cartListNew = cartTotalList;
            state.cartCount = state.cartListNew.filter(el => el.productItemId > 0).length;

            //            var num = state.cartListNew.reduce(function (a, b) {
            //                return (a + (b['quantity'] * b['price']));
            //            }, 0);
            state.cartAmount = parseFloat(num).toFixed(2);
            state.subTotal = parseFloat(state.totalDiscount) + parseFloat(state.cartAmount);
            state.cartStatus = true;
        },
        removeFromCart: (state, action) => {
            if (state.cartListNew.length > 0) {
                var exists = state.cartListNew.some(el => el.productItemId === action.payload.productItemId);
                if (exists) {
                    //                     console.log(action.payload.itemId);
                    state.cartListNew.map((item) => {
                        if (item.productItemId === action.payload.productItemId) {
                            if (action.payload.quantity === 0) {
                                item.quantity = 0;
                                item.totalQuantity = 0;
                            } else {
                                item.quantity -= 1;
                                item.totalQuantity -= 1;

                            }
                            return item;

                        }
                    });
                    if (state.cartListRemoved.length > 0) {
                        let newRemovedList = state.cartListNew.filter(el => el.quantity == 0);
                        state.cartListRemoved = [...state.cartListRemoved, ...newRemovedList];
                    } else {
                        state.cartListRemoved = state.cartListNew.filter(el => el.quantity == 0);
                    }
                    //                    state.cartListRemoved = state.cartListNew.filter(el => el.quantity == 0);
                    state.cartListNew = state.cartListNew.filter(el => el.quantity !== 0);
                }
                let cartTotalList = [];
                let num = 0;
                state.totalDiscount = 0;
                let cartProducts = JSON.parse(JSON.stringify(state.cartListNew.filter(el => el.productItemId > 0)));
                //            console.log(cartProducts);
                cartProducts.forEach((cp, index) => {
                    let cps = {};
                    let free = {};
                    let extra = {};
                    var mrp = parseFloat(cp.mrpPrice).toFixed(2);
                    var sprice = parseFloat(cp.salesPrice).toFixed(2);
                    cps.productItemId = cp.productItemId;
                    cps.productName = cp.productName;
                    cps.categoryId = cp.categoryId;
                    cps.categoryName = cp.categoryName;
                    cps.image = cp.image;
                    cps.quantity = cp.quantity;
                    cps.totalQuantity = cp.quantity;
                    cps.stock = cp.stock;
                    cps.offer_type = cp.offer_type;
                    cps.value_type = cp.value_type;
                    cps.offer_Value = cp.offer_Value;
                    cps.offer_quantity = cp.offer_quantity;
                    cps.offer_products_id = cp.offer_products_id;
                    cps.offer_free_quantity = cp.offer_free_quantity;
                    cps.mrpPrice = mrp;
                    cps.salesPrice = sprice;
                    cps.badge = "";
                    cps.status = 1;
                    if (cp.offer_type === 3) {
                        if (cp.value_type === 0) {
                            cps.price = (mrp - ((cp.offer_Value / 100) * mrp)).toFixed(2);
                            cps.badge = cp.offer_Value + "%";
                        }
                        if (cp.value_type === 1) {
                            cps.price = (mrp - cp.offer_Value).toFixed(2);
                            cps.badge = "₹" + cp.offer_Value;
                        }
                        //                                    console.log((cart.mrpPrice - cart.price) * cart.quantity);
                        state.totalDiscount += (mrp - cps.price) * cp.quantity;
                    } else if (cp.offer_type === 4) {
                        cps.price = mrp;
                        cps.badge = "BOGO";
                    } else if (cp.offer_type === 5) {
                        if (cp.quantity >= cp.offer_quantity) {
                            cps.badge = "Free";
                            cps.price = mrp;
                            cps.free_product = cp.offer_products_id;
                            let x = Math.floor(cp.quantity / cp.offer_quantity);
                            cps.offer_product_quantity = x;
                            const offPro = (state.freeProducts || []).filter(fp =>
                                fp.offer_products_id === cp.offer_products_id
                            )
                            if (offPro.length > 0) {
                                const fp = offPro[0];
                                free.productName = fp.ProductName ?? fp.productName ?? "Free Item";
                                free.image = Array.isArray(fp.image) ? fp.image[0] : fp.image ?? "";
                                free.offer_products_id = fp.offer_products_id;
                                free.price = 0;
                                free.mrpPrice = 0;
                                free.badge = "Free Product";
                                free.quantity = x * cp.offer_free_quantity;
                                free.totalQuantity = x * cp.offer_free_quantity;
                                free.status = 1;
                            }
                            if ((cp.quantity % cp.offer_quantity) > 0) {
                                let difference = (cp.quantity % cp.offer_quantity);
                                extra.productName = cp.productName;
                                extra.image = cp.image;
                                extra.price = sprice;
                                extra.mrpPrice = mrp;
                                extra.badge = "";
                                extra.quantity = difference;
                                extra.totalQuantity = difference;
                                cps.totalQuantity -= difference;
                            }
                        } else {
                            cps.price = sprice;
                        }
                    } else {
                        cps.price = sprice;
                    }
                    cartTotalList.push(cps);
                    if (cp.offer_type === 5 && free.price == 0) {
                        cartTotalList.push(free);
                    }
                    if (extra.price) {
                        num += extra.quantity * extra.price;
                        cartTotalList.push(extra);
                    }
                    //                                cps.totalQuantity = cp.quantity;
                    num += cps.totalQuantity * cps.price;
                });
                //            state.cartListStatus=state.cartListNew;
                state.cartListNew = cartTotalList;


                state.cartCount = state.cartListNew.filter(el => el.productItemId > 0).length;
                //                let num = state.cartListNew.reduce(function (a, b) {
                //                    return (a + (b['quantity'] * b['price']));
                //                }, 0);
                state.cartAmount = parseFloat(num).toFixed(2);
                state.subTotal = parseFloat(state.totalDiscount) + parseFloat(state.cartAmount);
                state.cartStatus = true;
            }
        },
        resetOrderFlow(state) {
            state.placeOrderStatus = false;
            state.orderId = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addCart.fulfilled, (state) => {
                state.cartStatus = false;
            })
            .addCase(addCart.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(clearCartApi.pending, (state) => {
                state.mutating = true;
            })
            .addCase(clearCartApi.fulfilled, (state, action) => {
                state.mutating = false;
                if (action.payload?.status !== "SUCCESS") return;

                // what we asked the API to delete
                const args = action.meta?.arg || {};
                const norm = (ids) => Array.isArray(ids)
                    ? ids.map(Number).filter(Boolean)
                    : String(ids ?? "")
                        .split(",")
                        .map((s) => Number(s.trim()))
                        .filter(Boolean);

                const productItemIds = norm(args.productItemIds);
                const cartIds = norm(args.cartIds);
                const isTargeted = productItemIds.length > 0 || cartIds.length > 0;

                if (!isTargeted) {
                    state.cartListNew = [];
                    state.cartListRemoved = [];
                    state.freeProducts = [];
                    state.cartCount = 0;
                    state.cartAmount = 0;
                    state.totalDiscount = 0;
                    state.subTotal = 0;
                    return;
                }
                const shouldRemove = (item) =>
                    (productItemIds.length && productItemIds.includes(Number(item.productItemId))) ||
                    (cartIds.length && cartIds.includes(Number(item.cartId)));

                const remaining = state.cartListNew.filter((i) => !shouldRemove(i));

                // recompute totals (keep numbers in store)
                let qty = 0, amt = 0, disc = 0;
                remaining.forEach((cp) => {
                    const q = Number(cp.totalQuantity || cp.quantity || 0);
                    const mrp = Number(cp.mrpPrice);
                    const price = Number(cp.price ?? cp.salesPrice);
                    qty += q;
                    amt += q * price;
                    if (cp.offer_type === 3) {
                        const discounted = cp.value_type === 0
                            ? (mrp - (cp.offer_Value / 100) * mrp)
                            : (mrp - cp.offer_Value);
                        disc += (mrp - discounted) * q;
                    }
                });

                state.cartListNew = remaining;
                state.cartCount = qty;
                state.cartAmount = Number(amt);
                state.totalDiscount = Number(disc);
                state.subTotal = Number(amt + disc);
            })

            .addCase(clearCartApi.rejected, (state, action) => {
                state.mutating = false;
                state.error = action.error?.message || "Failed to clear cart";
            })
            .addCase(fetchCart.pending, (state, action) => {
                state.loading = true;
                state.lastFetchCartRequestId = action.meta.requestId;
            })

            .addCase(fetchCart.fulfilled, (state, action) => {
                if (state.lastFetchCartRequestId !== action.meta.requestId) return;
                state.loading = false;
                if (action.payload.status === "SUCCESS") {
                    const cartProducts = action.payload.data.cartList;
                    const offerFreeProducts = action.payload.data.freeProducts;
                    state.cartCount = cartProducts.length;
                    // state.cartCount = cartProducts.reduce((sum, p) => sum + (p.quantity || 0), 0);
                    state.freeProducts = offerFreeProducts || [];
                    state.wishListCount = action.payload.data.wishListCount || 0;
                    state.totalDiscount = 0;
                    let num = 0;
                    const cartTotalList = [];
                    // console.log(cartProducts, "cartProducts");
                    cartProducts.forEach((cp, index) => {
                        let cps = {};
                        let free = {};
                        let extra = {};
                        cps.productItemId = cp.productItemId;
                        cps.productName = cp.productName;
                        cps.categoryId = cp.categoryId;
                        cps.categoryName = cp.categoryName;
                        cps.image = cp.image;
                        cps.quantity = cp.quantity;
                        cps.totalQuantity = cp.quantity;
                        cps.stock = cp.stock;
                        cps.offer_type = cp.offer_type;
                        cps.value_type = cp.value_type;
                        cps.offer_Value = cp.offer_Value;
                        cps.offer_quantity = cp.offer_quantity;
                        cps.offer_products_id = cp.offer_products_id;
                        cps.offer_free_quantity = cp.offer_free_quantity;
                        cps.mrpPrice = cp.mrpPrice.toFixed(2);
                        cps.salesPrice = cp.price.toFixed(2);
                        cps.badge = "";
                        cps.status = 1;
                        if (cp.offer_type === 3) {
                            if (cp.value_type === 0) {
                                cps.price = (cp.mrpPrice - ((cp.offer_Value / 100) * cp.mrpPrice)).toFixed(2);
                                cps.badge = cp.offer_Value + "%";
                            }
                            if (cp.value_type === 1) {
                                cps.price = (cp.mrpPrice - cp.offer_Value).toFixed(2);
                                cps.badge = "₹" + cp.offer_Value;
                            }
                            //                                    console.log((cart.mrpPrice - cart.price) * cart.quantity);
                            state.totalDiscount += (cp.mrpPrice - cps.price) * cp.quantity;
                        } else if (cp.offer_type === 4) {
                            cps.price = cp.mrpPrice.toFixed(2);
                            cps.badge = "BOGO";
                        } else if (cp.offer_type === 5) {
                            if (cp.quantity >= cp.offer_quantity) {
                                cps.badge = "Free";
                                cps.price = cp.mrpPrice.toFixed(2);
                                cps.free_product = cp.offer_products_id;
                                let x = Math.floor(cp.quantity / cp.offer_quantity);
                                cps.offer_product_quantity = x;
                                var offPro = offerFreeProducts.filter(function (el) {
                                    return el.offer_products_id == cp.offer_products_id;
                                });
                                if (offPro.length > 0) {
                                    free.productName = offPro[0].ProductName;
                                    free.image = offPro[0].image[0];
                                    free.offer_products_id = offPro[0].offer_products_id;
                                    free.price = 0;
                                    free.mrpPrice = 0;
                                    free.badge = "Free Product";
                                    free.quantity = x * cp.offer_free_quantity;
                                    free.totalQuantity = x * cp.offer_free_quantity;
                                    free.status = 1;
                                }
                                if ((cp.quantity % cp.offer_quantity) > 0) {
                                    let difference = (cp.quantity % cp.offer_quantity);
                                    extra.productName = cp.productName;
                                    extra.image = cp.image;
                                    extra.price = cp.price.toFixed(2);
                                    extra.mrpPrice = cp.mrpPrice.toFixed(2);
                                    extra.badge = "";
                                    extra.quantity = difference;
                                    extra.totalQuantity = difference;
                                    cps.totalQuantity -= difference;
                                }
                            } else {
                                cps.price = cp.price.toFixed(2);
                            }
                        } else {
                            cps.price = cp.price.toFixed(2);
                        }
                        cartTotalList.push(cps);
                        if (cp.offer_type === 5 && free.price == 0) {
                            cartTotalList.push(free);
                        }
                        if (extra.price) {
                            num += extra.quantity * extra.price;
                            cartTotalList.push(extra);
                        }
                        //                                cps.totalQuantity = cp.quantity;
                        num += cps.totalQuantity * cps.price;
                    });

                    state.cartListNew = cartTotalList;
                    state.cartAmount = parseFloat(num).toFixed(2);
                    state.subTotal = parseFloat(state.totalDiscount) + parseFloat(state.cartAmount);
                }
            })
            .addCase(fetchCart.rejected, (state, action) => {
                if (state.lastFetchCartRequestId !== action.meta.requestId) return;
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchDeliverySlot.fulfilled, (state, action) => {
                state.deliverySlot = action.payload.data;
                state.timeSlot = Object.values(action.payload.data)[0];
            })
            .addCase(fetchDeliverySlot.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(fetchTakeawaySlot.fulfilled, (state, action) => {
                state.deliverySlot = action.payload.data;
                state.timeSlot = Object.values(action.payload.data)[0];
            })
            .addCase(fetchTakeawaySlot.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(fetchDeliveryAddress.fulfilled, (state, action) => {
                state.deliveryAddress = action.payload.data.result;
            })
            .addCase(fetchDeliveryAddress.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(checkCartStatus.fulfilled, (state, action) => {
                if (action.payload.status === "SUCCESS" && action.payload.data.outofStock > 0) {
                    state.outOfStock = true;
                } else {
                    state.error = "error";
                }
            })
            .addCase(checkCartStatus.rejected, (state, action) => {
                state.error = action.error.message;
            })
            .addCase(placeOrder.fulfilled, (state, action) => {
                if (action.payload.status === "SUCCESS") {
                    state.placeOrderStatus = true;
                    state.orderId = action.payload.data.orderId;
                    state.cartCount = 0;
                    state.cartAmount = 0;
                    state.totalDiscount = 0;
                    state.subTotal = 0;
                    state.cartListNew = [];
                    state.cartListRemoved = [];
                    state.freeProducts = [];
                } else {
                    state.error = action.payload.message;
                }
            })
            .addCase(placeOrder.rejected, (state, action) => {
                state.error = action.error.message;
            });
    },
});

export default cartSlice.reducer;

export const {
    changeStateTrue,
    changeStateFalse,
    clearResponse,
    clearState,
    addToCart,
    removeFromCart,
    clearStock,
    resetOrderFlow,
} = cartSlice.actions;
